import AppInitializer from '../AppInitializer';
import AuthManager from '~system/auth/AuthManager';
import App from './App';

AuthManager.checkTenantAndLogin().then(data =>{ // 테넌트 및 로그인 여부 확인
  console.log('loggedIn : ', data.loggedIn);

  if (data.loggedIn) { // 로그인 상태
    AuthManager.login().then(loginData => { // 로그인 정보 조회
      const appInitializer = new AppInitializer();
      appInitializer.createVueApp(App, loginData);
    }).catch(err => {
      console.warn(err);
    });

  } else { // 로그아웃 상태
    const appInitializer = new AppInitializer();
    appInitializer.createVueApp(App);
  }
}).catch(err => {
  console.warn(err);
});